import Translation from './translation'

export default class Attachment extends Translation
{
    get active_ar() {
        return this.locales.includes('ar');
    }

    get active_en() {
        return this.locales.includes('en');
    }
    
    get active_fa() {
        return this.locales.includes('fa');
    }

    set File(value){
        if(value != null){
            this.file = value
            this.url = this.file.value
        }else{
            this.file = null
            this.url = this.attachment_url
        }
    }

    constructor(attachment){
        super()
        this.id             = 0
        
        this.locales        = ['ar']
        
        this.title_ar       = ''
        this.title_en       = ''
        this.title_fa       = ''
        
        this.description_ar = null
        this.description_en = null
        this.description_fa = null

        this.file           = null
        this.attachment_url = null
        this.url            = null

        this.map(attachment)
        this.init()
    }

    map(attachment){
        if(attachment == undefined) return

        this.id             = attachment.id
        this.attachment_url = attachment.attachment_url
        this.url            = attachment.attachment_url
        
        this.created_at     = attachment.created_at  
        this.updated_at     = attachment.updated_at  

        for (let locale in attachment.translations) {
            this['title_' + locale]   = attachment.translations[locale].title
            this['description_' + locale] = attachment.translations[locale].description
            this.locales.push(locale);
        }
        this.setLocale(this.locales)
    }

    toFormData(){
        let fData = new FormData()
        
        for(let locale of this.locales){

            fData.append('translation['+ locale +'][title]', this['title_'+ locale]);
            fData.append('translation['+ locale +'][description]', this['description_'+ locale]);
        }
        
        if(this.file != null){
            fData.append('file', this.file);
        }

        return fData
    }
}

